import Vue from "vue";
import VueResource from "vue-resource";
import App from "./App.vue";
import router from "./router"; //路由
import config from "./config/";
import iView from "iview"; //组件库
import "iview/dist/styles/iview.css"; //组件库
import Vant from "vant"; //组件库
import "vant/lib/index.css"; //组件库
import axios from "axios"; //api
import Share from "vue-social-share"; //社交分享
import scroll from "vue-infinite-auto-scroll"; //自动滚动列表组件
import MuseUI from "muse-ui"; //材料设计组件库
import "muse-ui/dist/muse-ui.css"; //材料设计组件库
import Mint from "mint-ui";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import AnalysysAgent from 'ans-javascript-sdk/sdk/AnalysysAgent_JS_SDK.es6.min.js' //易观

Vue.use(AnalysysAgent);
Vue.use(ElementUI);
Vue.use(scroll);
Vue.use(Share);
Vue.use(iView);
Vue.use(Vant);
Vue.use(MuseUI);
Vue.use(VueResource);
Vue.use(axios);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$config = config;
window._ = require("lodash");
import { Lazyload } from "vant";
Vue.use(Lazyload);
Vue.use(Mint);
new Vue({
  router,
  render: (h) => h(App),
  created: function() {},
}).$mount("#app");
